<template>
  <b-modal
    :id="modalId"
    centered
    title="Confirmation Action Project"
    @hide="$emit('close')"
    hide-header-close
    @show="resetModal"
    @hidden="onHidden"
    @ok.prevent="handleOk"
    size="md"
  >
    <div class="p-2 d-flex flex-column gap-4">
      <b-row class="d-flex flex-column rounded bg-dark-soft p-4 gap-3">
        <b-row>
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Project Name</label>
            <h4>{{ data?.project?.name }}</h4>
          </b-col>
          <b-col class="d-flex flex-column gap-1 col-6">
            <label>Action Type</label>
            <h4>{{ snakeToTitle(type) }}</h4>
          </b-col>
        </b-row>
      </b-row>
      <b-form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          v-if="type !== 'approved'"
          label="Notes"
          :state="getState('notes')"
          invalid-feedback="Notes is required."
        >
          <b-form-textarea rows="2" v-model="form.notes" placeholder="Notes" :state="getState('notes')" />
        </b-form-group>
      </b-form>
    </div>

    <template #modal-footer>
      <b-button variant="primary" @click="handleOk" :disabled="isLoading" :key="isLoading">
        <b-spinner v-if="isLoading" small type="grow" class="me-2"></b-spinner>
        <span>{{ isLoading ? "Submitting..." : "Submit" }}</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { formatDate, getTrainingStatusClass, snakeToTitle, cleanObject } from "../utils/utils";

export default {
  name: "ActionProjectModal",

  props: {
    modalId: { type: String, default: "action-project-modal" },
    data: { type: Object, default: null },
    type: { type: String, default: null },
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      form: this.getInitialForm(),
      submitted: false,
      formErrors: {},
      suppressValidation: false,
    };
  },

  methods: {
    formatDate,
    getTrainingStatusClass,
    snakeToTitle,

    clearError(field) {
      if (this.formErrors[field]) {
        this.$delete(this.formErrors, field);
      }
    },

    getState(field) {
      if (this.formErrors[field]) return false;
      return null;
    },

    onHidden() {
      this.resetModal();
      this.$emit("close");
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },

    validateAll() {
      this.formErrors = {};

      if (!this.form.notes) this.formErrors.notes = "Notes is required.";

      return Object.keys(this.formErrors).length === 0;
    },

    handleSubmit() {
      const isValid = this.validateAll();
      if (!isValid) return;

      const payload = { ...this.form, type: this.type };

      this.$emit("submit-action", cleanObject(payload));
    },

    getInitialForm() {
      return {
        notes: null,
        id: this.data?.id,
        type: null,
      };
    },

    async resetModal() {
      if (this.isLoading) return;

      this.suppressValidation = true;

      await this.$nextTick();

      this.form = this.getInitialForm();
      this.formErrors = {};
      this.selectedFile = null;
      this.previewUrl = null;

      this.$nextTick(() => {
        this.suppressValidation = false;
      });
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped>
.dropzone {
  background-color: #f8f9fa;
  border: 2px dashed #dee2e6 !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dropzone:hover,
.dropzone.border-danger {
  border-color: #e63757 !important;
  background-color: #fff5f7;
}

.dropzone.is-invalid {
  border-color: #dc3545 !important;
}

.course-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fce4e4;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gap-2 {
  gap: 0.5rem;
}

.me-1 {
  margin-right: 0.25rem;
}

.me-2 {
  margin-right: 0.5rem;
}

.me-3 {
  margin-right: 1rem;
}

/* PDF Preview Styles */
.pdf-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.pdf-preview .pdf-icon-container {
  width: 80px;
  height: 100px;
  background: linear-gradient(135deg, #e63757 0%, #c82333 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(230, 55, 87, 0.3);
}

.pdf-preview .pdf-icon-container i {
  font-size: 2.5rem;
  color: #fff;
}

.pdf-preview .pdf-label {
  margin-top: 1rem;
  font-weight: 600;
  color: #1a202c;
}

:deep(.table-header) {
  font-size: 11px !important;
}

:deep(.vgt-table td, .vgt-table th) {
  font-size: 11px !important;
}
</style>
